import styled from '@emotion/styled';

export const ChartWrapper = styled.div`
    height: 100%;
    width: 100%;
    min-height: 0;
`;
